import common from './common';
import routes from './routes';

export default {
  common,
  routes,
};
